// src/layouts/Root.jsx
import React from "react";
import TopNavLayout from "../components/Sidebar";
import SubscriptionGate from "../components/SubscriptionGate";
import TrialSubscriptionGuard from "../components/TrialSubscriptionGuard";

const Root = ({ children }) => (
  <TrialSubscriptionGuard>
    <TopNavLayout>
      <SubscriptionGate>{children}</SubscriptionGate>
    </TopNavLayout>
  </TrialSubscriptionGuard>
);

export default Root;
